import { isModuleUnlocked } from '@/components/layout/helpers';
import { unitMoney } from '@/components/settings/estimating/materials/materialFormat';

export { unitMoney };

// The Assemblies page shows only when the add-on is unlocked AND Strata Estimating is on.
export const estimatingOpen = (user) =>
  isModuleUnlocked('estimating_enabled', user?.integration_flags) && user?.estimating_mode === 'strata';

export const KINDS = [
  { kind: 'material', bucket: 'material', label: 'Materials' },
  { kind: 'labor', bucket: 'labor', label: 'Labor' },
  { kind: 'equipment', bucket: 'equipment', label: 'Equipment' },
  { kind: 'sub', bucket: 'subcontractor', label: 'Subcontractors' },
];

export const byName = (a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });

export const money = (n) => `$${Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const fmtNum = (n) => Number(n || 0).toLocaleString('en-US', { maximumFractionDigits: 4 });
export const pct = (n) => `${fmtNum(n)}%`;
export const rateLabel = (r) => `${money(r)}/hr`;
// Labor hours (man-hours): labor is priced at an average $ per labor hour, never by crew.
export const laborHrs = (n) => `${fmtNum(n)} labor hr${Number(n) === 1 ? '' : 's'}`;
// The labor rates a labor item in this division may pick (`rates` = the options' labor_rates): the division's own first,
// then the company-wide ones, active only (plus `keep`, the one it already points at).
export const laborRatesFor = (rates, divisionId, keep) => (rates || [])
  .filter((r) => r.id === keep || (r.active && (r.division_id == null || r.division_id === divisionId)))
  .sort((x, y) => (x.division_id == null) - (y.division_id == null));
export const laborRateLabel = (r) => `${r.name} · ${rateLabel(r.rate)}${r.division_id == null ? ' · company-wide' : ''}`;

// '1,250.5' / '$4' / '5%' → { value } or { error }.
export function parseNum(raw, max, what = 'a number') {
  const s = String(raw ?? '').replace(/[\s$,%]/g, '');
  if (!s) return { value: 0 };
  const v = Number(s);
  if (!Number.isFinite(v)) return { error: `Enter ${what}, e.g. 1.5.` };
  if (v < 0 || v > max) return { error: `Enter ${what} between 0 and ${max.toLocaleString('en-US')}.` };
  return { value: Math.round(v * 10000) / 10000 };
}

export const detail = (e, fallback) => (typeof e?.response?.data?.detail === 'string' ? e.response.data.detail : fallback);

export const matchesQuery = (name, q) => {
  const terms = q.trim().toLowerCase().split(/\s+/).filter(Boolean);
  const hay = name.toLowerCase();
  return terms.every((t) => hay.includes(t));
};
